import React, { useState, useEffect } from 'react';
import './SocialBar.css';
import { useMediaQuery } from 'react-responsive';
import logo from '../assets/logo.png';

const SocialBar = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className={`social-bar ${isVisible ? 'animate-fadeIn' : ''}`}>
      <div className="social-container">
        {isMobile && (
          <div className="social-logo animate-fadeInUp">
            <img src={logo} alt="Basketball Culture Logo" />
          </div>
        )}
        <div className="social-links">
          {[
            { icon: 'youtube', url: 'https://www.youtube.com/@BasketballCulturePodcast' },
            { icon: 'instagram', url: 'https://www.instagram.com/xbasketballculture/' },
            { icon: 'tiktok', url: 'https://www.tiktok.com/@xbasketball.culture' },
            { icon: 'spotify', url: 'https://open.spotify.com/show/5PeXtBE6kOmkQkY6apnagZ' }
          ].map((social, index) => (
            <a 
              key={social.icon}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`animate-fadeInUp stagger-delay-${index}`}
            >
              <i className={`fab fa-${social.icon}`}></i>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SocialBar;
